import Footer from "../components/Footer";
import Navbar from "../components/Navbar"

export const PolatliBlog: React.FC = () => {
    return (
        <div>
            <Navbar />
        <div className="bg-gray-50 p-8">
            
            <div className="max-w-4xl mx-auto">
                <h1 className="text-5xl font-bold text-[#092049] mb-8 text-center">
                    Polatlı Personel Taşımacılık Hizmetleri
                </h1>
                <p className="text-lg leading-relaxed text-gray-700 mb-6">
                    Polatlı, hızla büyüyen bir şehir olarak, personel taşımacılığı ihtiyacının giderek arttığı bir merkez haline gelmiştir. İşletmeler, çalışanlarının işe güvenli, hızlı ve konforlu bir şekilde ulaşmasını sağlamak için profesyonel personel taşımacılık hizmetlerine ihtiyaç duymaktadır.
                </p>
                {/*<img
                    src="https://via.placeholder.com/800x400"
                    alt="Polatlı personel taşımacılık"
                    className="rounded-lg shadow-lg mb-6"
                />
                */}
                <p className="text-lg leading-relaxed text-gray-700 mb-6">
                    Polatlı’daki personel taşımacılık hizmetlerimiz, yılların deneyimi ile şekillenmiştir. Şehrin trafiğine hâkim uzman şoförlerimiz ve konforlu araçlarımız sayesinde, personelinizin işe zamanında ve stressiz bir şekilde ulaşmasını sağlıyoruz. Hizmetlerimizi planlarken, her işletmenin farklı ihtiyaçlarına uygun çözümler sunmayı hedefliyoruz.
                </p>
                <h2 className="text-3xl font-semibold text-[#092049] mb-4">
                    Neden Polatlı Personel Taşımacılık Hizmetleri?
                </h2>
                <ul className="list-disc list-inside text-lg text-gray-700 mb-6">
                    <li>Güvenli ve profesyonel şoförler</li>
                    <li>Konforlu ve bakımlı araç filosu</li>
                    <li>Zamanında ulaşım garantisi</li>
                    <li>İşletmenizin özel ihtiyaçlarına uygun çözümler</li>
                </ul>
                <p className="text-lg leading-relaxed text-gray-700 mb-6">
                    Polatlı personel taşımacılığı hizmetlerimizle ilgili daha fazla bilgi almak ve işletmenize özel bir plan oluşturmak için bize ulaşabilirsiniz. Çalışanlarınızın memnuniyetini ve işletmenizin verimliliğini artırmak için buradayız.
                </p>
                <a
                    href="/iletisim"
                    className="bg-[#092049] text-white px-6 py-3 rounded-lg shadow-lg hover:bg-cyan-600 transition duration-300 inline-block"
                >
                    İletişime Geçin
                </a>
            </div>
        </div>
        <Footer     />
        </div>
    );
};
